import {
  getLeoUuid,
  LeoUUID,
  getString,
  getLeoTimestamp,
  LeoTimestamp,
} from "@surya-digital/leo-ts-types";

export interface GetActiveSpocProjectsPaginationResponseDTO {
  projectId: string;
  projectName: string;
  creator: string;
  surveys: string;
  createdOn: string;
  lastModified: string;
  spocId: string;
}

export class GetActiveSpocProjectsPaginationResponse {
  readonly isGetActiveSpocProjectsPaginationResponseGetActiveSpocProjectsPaginationResponse: boolean = true;

  readonly projectId: LeoUUID;
  readonly projectName: string;
  readonly creator: string;
  readonly surveys: string;
  readonly createdOn: LeoTimestamp;
  readonly lastModified: LeoTimestamp;
  readonly spocId: LeoUUID;


  constructor(
  projectId: LeoUUID, 
  projectName: string, 
  creator: string, 
  surveys: string, 
  createdOn: LeoTimestamp, 
  lastModified: LeoTimestamp, 
  spocId: LeoUUID
  ) {
    this.projectId = projectId;
    GetActiveSpocProjectsPaginationResponse.validateProjectName(projectName);
    this.projectName = projectName;
    GetActiveSpocProjectsPaginationResponse.validateCreator(creator);
    this.creator = creator;
    GetActiveSpocProjectsPaginationResponse.validateSurveys(surveys);
    this.surveys = surveys;
    this.createdOn = createdOn;
    this.lastModified = lastModified;
    this.spocId = spocId;
  }

  static fromDTO(dto: GetActiveSpocProjectsPaginationResponseDTO): GetActiveSpocProjectsPaginationResponse {
    const projectId = getLeoUuid(dto, "projectId", InvalidGetActiveSpocProjectsPaginationResponseProjectIdError);
    const projectName = getString(dto, "projectName", InvalidGetActiveSpocProjectsPaginationResponseProjectNameError);
    const creator = getString(dto, "creator", InvalidGetActiveSpocProjectsPaginationResponseCreatorError);
    const surveys = getString(dto, "surveys", InvalidGetActiveSpocProjectsPaginationResponseSurveysError);
    const createdOn = getLeoTimestamp(dto, "createdOn", InvalidGetActiveSpocProjectsPaginationResponseCreatedOnError);
    const lastModified = getLeoTimestamp(dto, "lastModified", InvalidGetActiveSpocProjectsPaginationResponseLastModifiedError);
    const spocId = getLeoUuid(dto, "spocId", InvalidGetActiveSpocProjectsPaginationResponseSpocIdError);
    return new GetActiveSpocProjectsPaginationResponse(
      projectId,
      projectName,
      creator,
      surveys,
      createdOn,
      lastModified,
      spocId
    );
  }

  toDTO(): GetActiveSpocProjectsPaginationResponseDTO {
    const dto: GetActiveSpocProjectsPaginationResponseDTO = {
        projectId: this.projectId.toDTO(),
        projectName: this.projectName,
        creator: this.creator,
        surveys: this.surveys,
        createdOn: this.createdOn.toDTO(),
        lastModified: this.lastModified.toDTO(),
        spocId: this.spocId.toDTO()
    };
    return dto;
  }
  private static validateProjectName = (projectName: string): void => {
    if(projectName.trim().length === 0) {
      throw new InvalidGetActiveSpocProjectsPaginationResponseProjectNameNonEmptyError(
        `Attribute projectName cannot be an empty string.`
      );
    }
  }
  private static validateCreator = (creator: string): void => {
    if(creator.trim().length === 0) {
      throw new InvalidGetActiveSpocProjectsPaginationResponseCreatorNonEmptyError(
        `Attribute creator cannot be an empty string.`
      );
    }
  }
  private static validateSurveys = (surveys: string): void => {
    if(surveys.trim().length === 0) {
      throw new InvalidGetActiveSpocProjectsPaginationResponseSurveysNonEmptyError(
        `Attribute surveys cannot be an empty string.`
      );
    }
  }
  
}

GetActiveSpocProjectsPaginationResponse.prototype.toString = function toString(): string {
  return `GetActiveSpocProjectsPaginationResponse(projectId='${this.projectId}',projectName='${this.projectName}',creator='${this.creator}',surveys='${this.surveys}',createdOn='${this.createdOn}',lastModified='${this.lastModified}',spocId='${this.spocId}')`;
};

export class InvalidGetActiveSpocProjectsPaginationResponseError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetActiveSpocProjectsPaginationResponseError";
  }
}
export class InvalidGetActiveSpocProjectsPaginationResponseProjectIdError extends InvalidGetActiveSpocProjectsPaginationResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetActiveSpocProjectsPaginationResponseProjectIdError";
  }
}

export class InvalidGetActiveSpocProjectsPaginationResponseProjectNameError extends InvalidGetActiveSpocProjectsPaginationResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetActiveSpocProjectsPaginationResponseProjectNameError";
  }
}

export class InvalidGetActiveSpocProjectsPaginationResponseProjectNameNonEmptyError extends InvalidGetActiveSpocProjectsPaginationResponseProjectNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetActiveSpocProjectsPaginationResponseProjectNameNonEmptyError";
  }
}

export class InvalidGetActiveSpocProjectsPaginationResponseCreatorError extends InvalidGetActiveSpocProjectsPaginationResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetActiveSpocProjectsPaginationResponseCreatorError";
  }
}

export class InvalidGetActiveSpocProjectsPaginationResponseCreatorNonEmptyError extends InvalidGetActiveSpocProjectsPaginationResponseCreatorError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetActiveSpocProjectsPaginationResponseCreatorNonEmptyError";
  }
}

export class InvalidGetActiveSpocProjectsPaginationResponseSurveysError extends InvalidGetActiveSpocProjectsPaginationResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetActiveSpocProjectsPaginationResponseSurveysError";
  }
}

export class InvalidGetActiveSpocProjectsPaginationResponseSurveysNonEmptyError extends InvalidGetActiveSpocProjectsPaginationResponseSurveysError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetActiveSpocProjectsPaginationResponseSurveysNonEmptyError";
  }
}

export class InvalidGetActiveSpocProjectsPaginationResponseCreatedOnError extends InvalidGetActiveSpocProjectsPaginationResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetActiveSpocProjectsPaginationResponseCreatedOnError";
  }
}

export class InvalidGetActiveSpocProjectsPaginationResponseLastModifiedError extends InvalidGetActiveSpocProjectsPaginationResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetActiveSpocProjectsPaginationResponseLastModifiedError";
  }
}

export class InvalidGetActiveSpocProjectsPaginationResponseSpocIdError extends InvalidGetActiveSpocProjectsPaginationResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetActiveSpocProjectsPaginationResponseSpocIdError";
  }
}
